// extracted by mini-css-extract-plugin
module.exports = {"content":"DownLoadWeb__content__ATHya","steps":"DownLoadWeb__steps__1184U","content_box":"DownLoadWeb__content_box__1iOUw","loading":"DownLoadWeb__loading__1CHtB"};